import React from 'react';
import './Legend.css';

const Legend = () => (
  <div className="map-legend">
    <h4>Legend</h4>
    <div className="legend-item">
        <span className={`legend-icon color-indicator blue`}></span>
        <span>Places to Stay</span>
    </div>
    <div className="legend-item">
        <span className={`legend-icon color-indicator green`}></span>
        <span>Places to Eat</span>
    </div>
    <div className="legend-item">
        <span className={`legend-icon color-indicator yellow`}></span>
        <span>Things to Do</span>
    </div>
    <div className="legend-item">
        <span className={`legend-icon color-indicator red`}></span>
        <span>Destinations</span>
    </div>
  </div>
);

export default Legend;